import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SESSION_KEYS } from 'src/app/shared/constants/params.constant';
import { StorageService } from 'src/app/shared/service/storage.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private storageService: StorageService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const valueJWT = this.storageService.get(SESSION_KEYS.UUID) as string;
    if (valueJWT) {
      const req = request.clone({
        setHeaders: { 'Authorization': `Bearer ${valueJWT}` }
      });
      return next.handle(req);
    }
    return next.handle(request);
  }
}
